// state.js

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  totalCourses: "",
  activeBatches: "",
  enrolledStudent: ""
};

export default initialState;
